import React, { useState } from 'react'
import UserProfileEdit from '../UserProfileEdit'
import UserProfileReadOnly from '../UserProfileReadOnly'
import UserProfileResetPassword from '../UserProfileResetPassword'
import UserProfileChangeMobilePhone from '../UserProfileChangeMobilePhone'
import UserProfileVerifyMobilePhone from '../UserProfileVerifyMobilePhone'
import UserProfileChangeEmailAddress from '../UserProfileChangeEmailAddress'
import UserProfileVerifyEmailAddress from '../UserProfileVerifyEmailAddress'

function UserProfileMain(): JSX.Element {
  const [currentPage, setCurrentPage] = useState('read-only')

  const nextPage = (page: string) => {
    console.log('nextPage main where page is ', page)
    if (page === 'read-only') {
      setCurrentPage('read-only')
    } else if (page === 'edit') {
      setCurrentPage('edit')
    } else if (page === 'reset') {
      setCurrentPage('reset')
    } else if (page === 'changeMobilePhone') {
      setCurrentPage('changeMobilePhone')
    } else if (page === 'changeMobilePhoneVerify') {
      setCurrentPage('changeMobilePhoneVerify')
    } else if (page === 'changeEmailAddress') {
      setCurrentPage('changeEmailAddress')
    } else if (page === 'changeEmailAddressVerify') {
      setCurrentPage('changeEmailAddressVerify')
    }
  }

  const previousPage = (page: string) => {
    setCurrentPage(page)
  }

  return (
    <>
      {currentPage === 'read-only' && (
        <UserProfileReadOnly nextPage={nextPage} />
      )}

      {currentPage === 'edit' && (
        <UserProfileEdit nextPage={nextPage} previousPage={previousPage} />
      )}

      {currentPage === 'reset' && (
        <UserProfileResetPassword
          nextPage={nextPage}
          previousPage={previousPage}
        />
      )}

      {currentPage === 'changeMobilePhone' && (
        <UserProfileChangeMobilePhone
          nextPage={nextPage}
          previousPage={previousPage}
        />
      )}

      {currentPage === 'changeMobilePhoneVerify' && (
        <UserProfileVerifyMobilePhone
          nextPage={nextPage}
          previousPage={previousPage}
        />
      )}

      {currentPage === 'changeEmailAddress' && (
        <UserProfileChangeEmailAddress
          nextPage={nextPage}
          previousPage={previousPage}
        />
      )}

      {currentPage === 'changeEmailAddressVerify' && (
        <UserProfileVerifyEmailAddress
          nextPage={nextPage}
          previousPage={previousPage}
        />
      )}
    </>
  )
}

export default UserProfileMain
